import { render, staticRenderFns } from "./FileOriginatingDevice.vue?vue&type=template&id=84312f4e&scoped=true"
import script from "./FileOriginatingDevice.vue?vue&type=script&lang=ts"
export * from "./FileOriginatingDevice.vue?vue&type=script&lang=ts"
import style0 from "./FileOriginatingDevice.vue?vue&type=style&index=0&id=84312f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84312f4e",
  null
  
)

export default component.exports